export default ({ request }) => ({
  orderExpenseItemListApi(data = {}) {
    return request({
      url: '/financial/order/expense/item/list',
      method: 'POST',
      data,
    })
  },
})
